export const CURRENCY = 'PLN'
